import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label } from 'reactstrap';

import MonthPicker from '../DatePicker/MonthPicker';

class MoveInDateFields extends Component {
  render() {
    return (
      <div>
        <FormGroup>
          <Label for="date">When did you move in?</Label>
          <MonthPicker name="moveInDate" value={this.props.moveInDate} onChange={this.props.handleChange} error={this.props.validation.moveInDate.isInvalid} errorMessage={this.props.validation.moveInDate.message} autoFocus={this.props.autoFocus} />
        </FormGroup>                          
      </div>);
  }
}
MoveInDateFields.defaultProps= {
  handleChange:() => {},
  validation: {
    moveInDate: {
      isInvalid: false,
      message: ""
    }
  },
  autoFocus: false
};

MoveInDateFields.propTypes = {
  handleChange: PropTypes.func,
  autoFocus: PropTypes.bool
};

export default MoveInDateFields;


// WEBPACK FOOTER //
// ./src/components/Fields/MoveInDateFields.js